export default __webpack_public_path__ + "static/media/PPI-firefeature-007.15789825.jpg";